import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent, implementFunction } from "../../../../framework/core/mvvm/module_base";
import EventManager from "../../../../manager/event_manager";
import { friend_utils } from "./friend_utils";
import ModuleManager from "../../../../framework/core/module_manager";
import LanguageManager from "../../../../manager/language_manager";
import Utility from "../../../../utility/utility";
import AudioManager from "../../../../manager/audio_manager";
import FriendTransferView from "./friend_transfer_view";
import { IUserCurrencyData } from "../../../../manager/user_manager";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit("FriendTransferModule")
export default class FriendTransferModule extends ModuleBase<FriendTransferView,null>{


    constructor(){
        super();

        this.layer = ViewLayer.Mid;
        this.modelType = null;
        this.viewType = FriendTransferView;
        this.needAnim = true;
        this.autoShowAnim = true
        this.needViewMask = true
        this.clickAnywhereClose = true;
        this.needViewBaseCloseBtn = true;
        this.needViewBaseTitleBg = true
        this.needViewBaseBgMid = true
        this.windowPrefabResPath = "package/hall/module/friend/friend_transfer"
        
    }

    onLoad(){

    }

    start(){        

    }


    @implementFunction('onSelfCurrencyDataUpdate')
    protected on_selfCurrencyDataUpdate(data: IUserCurrencyData) {
     
        this.view.updateCurrency(data.chip);
    }


    onShow(intentData?){

        if (intentData) {
        
            this.view.show(intentData.currency,intentData.transferRemain,intentData.friendData);
        }
        
    }    

    @bindButtonClickEvent("ConfirmBtn")
    onTransfer(){

        this.view.onTransfer();
    }

    @bindButtonClickEvent("ReduceBtn")
    onReduce(){

        this.view.onReduce();
    }


    @bindButtonClickEvent("AddBtn")
    onAdd(){
    
        this.view.onAdd();
    }


    onClose(){

        Utility.playButtonSound();
        this.hide();        
    }

    onDisable(){
        
    }

}
